//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["size_type","length_or_scale","height_or_aspect_ratio"],"GetSize",{},0,0],[["scale","aspect_ratio"],"SetScaleAndAspectRatio",{},2,0],[["length","height"],"SetLengthAndHeight",{},2,0]],[]];
SPLM.Annotations.UserSymbolPreferences = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.UserSymbolPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.UserSymbolPreferences.SizeType = Object.freeze({
    "LengthHeight" : "LengthHeight", "ScaleAspectRatio" : "ScaleAspectRatio"});

export default SPLM;